/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The TankHistory model module.
* @module model/TankHistory
* @version 2020-12-7
*/
export default class TankHistory {
    /**
    * Constructs a new <code>TankHistory</code>.
    * センサーが設置されていたタンクと撤去されたタンクの履歴
    * @alias module:model/TankHistory
    * @class
    * @param action {module:model/TankHistory.ActionEnum} センサー設置ステータス
    * @param customerId {Number} 顧客Id
    * @param tankId {Number} タンクID
    * @param timestamp {Number} 時刻
    */

    constructor(action, customerId, tankId, timestamp) {
        
        
        this['action'] = action;
        this['customerId'] = customerId;
        this['tankId'] = tankId;
        this['timestamp'] = timestamp;
        
    }

    /**
    * Constructs a <code>TankHistory</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/TankHistory} obj Optional instance to populate.
    * @return {module:model/TankHistory} The populated <code>TankHistory</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TankHistory();
                        
            
            if (data.hasOwnProperty('action')) {
                obj['action'] = ApiClient.convertToType(data['action'], 'String');
            }
            if (data.hasOwnProperty('customerId')) {
                obj['customerId'] = ApiClient.convertToType(data['customerId'], 'Number');
            }
            if (data.hasOwnProperty('tankId')) {
                obj['tankId'] = ApiClient.convertToType(data['tankId'], 'Number');
            }
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
        }
        return obj;
    }

    /**
    * センサー設置ステータス
    * @member {module:model/TankHistory.ActionEnum} action
    */
    'action' = undefined;
    /**
    * 顧客Id
    * @member {Number} customerId
    */
    'customerId' = undefined;
    /**
    * タンクID
    * @member {Number} tankId
    */
    'tankId' = undefined;
    /**
    * 時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;



    /**
    * Allowed values for the <code>action</code> property.
    * @enum {String}
    * @readonly
    */
    static ActionEnum = {
        /**
         * value: "installed"
         * @const
         */
        "installed": "installed",
        /**
         * value: "uninstalled"
         * @const
         */
        "uninstalled": "uninstalled"    };

}
